/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck;
import React, { useState } from 'react';
import { useTheme } from '@/providers/theme';
import {
  useSMmyPolicyDetailPage,
  useSMUpdateAckStatus,
  useSMBlockchainProof,
  useSMCancelPolicy,
  useSMTransactionList,
} from '@pages/PolicyDetailPage/machines';

import {
  HeroSection,
  Header,
  BackArrowComp,
  TimelineDetailModal,
  AcknowledgementModal,
  TransactionReceiptModal,
} from '../components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import {
  TweetyModal,
  ITweetyModalProps,
} from '@vlinder-web/tweety-modal-widget-react';

import { PolicyDetailPageService } from '@pages/PolicyDetailPage/services';
import { vappContainer } from '@/application';
import { useLocation } from 'react-router-dom';
import { usePolicyId } from '@pages/PolicyDetailPage/provider';

const getSrv = () => {
  return vappContainer.get<PolicyDetailPageService>(
    PolicyDetailPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [cardModal, setCardModal] = useState<boolean>(false);
  const [receiptModal, setReceiptModal] = useState<boolean>(false);
  const [ackModal, setAckModal] = useState<boolean>(false);
  const [cardId, setCardId] = useState<string>('');
  const [cancelModal, setCancelModal] = useState<boolean>(false);
  const staticPageContentConfig = getSrv()?.agent?.getStaticContentSync();
  const { policyNumber } = usePolicyId();
  const theme = useTheme();
  const { state } = useLocation();
  const srv = getSrv();
  const {
    myPolicyDetailPageMachine,
    myPolicyDetailPageState,
    myPolicyDetailPageSend,
  } = useSMmyPolicyDetailPage({});

  const { updateAckStatusSend, updateAckStatusState } = useSMUpdateAckStatus(
    {}
  );

  const { blockchainProofMachine, blockchainProofSend, blockchainProofState } =
    useSMBlockchainProof({});

  const { cancelPolicyMachine, cancelPolicySend, cancelPolicyState } =
    useSMCancelPolicy({});

  const { transactionListMachine, transactionListSend, transactionListState } =
    useSMTransactionList({});

  const onRefresh = () => {};

  const onHeroButtonClick = (key: string) => {
    console.log('button click', key);
    if (key === 'download') {
      document.getElementById('downloadPolicy')?.click();
    }
    if (key === 'weather') {
      props?.onWeatherClick && props?.onWeatherClick(policyNumber);
    }
    if (key === 'acknowledge') {
      if (!ackModal) {
        setAckModal(true);
      }
    }
    if (key === 'cancel') {
      if (!cancelModal) {
        setCancelModal(true);
      }
    }
  };

  const onAckSubmit = (data: any) => {
    console.log(`ack submit`, data);
    if (ackModal) {
      setAckModal(!ackModal);
    }
    updateAckStatusSend('START', {
      payload: data,
    });
  };

  const _renderNotification = () => {
    if (updateAckStatusState?.matches('UPDATE_ACK_STATUS_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notification?.updateAckSuccess || {})}
          onAcknowledgement={props?.goBack}
          onDeny={props?.goBack}
        />
      );
    }
    if (cancelPolicyState?.matches('CANCEL_POLICY_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notification?.cancelSuccess || {})}
          onAcknowledgement={props?.goBack}
          onDeny={props?.goBack}
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (myPolicyDetailPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getTemplateList || {})}
          onAcknowledgement={props?.goBack}
          onDeny={props?.goBack}
        />
      );
    }
    if (updateAckStatusState?.matches('UPDATE_ACK_STATUS_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getTemplateList || {})}
          onAcknowledgement={props?.goBack}
          onDeny={props?.goBack}
        />
      );
    }
    if (cancelPolicyState?.matches('CANCEL_POLICY_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.cancelError || {})}
          onAcknowledgement={props?.goBack}
          onDeny={props?.goBack}
        />
      );
    }
  };

  const _renderAnchorLink = () => {
    return (
      <a
        download={myPolicyDetailPageState?.event?.data?.value?.title}
        href={myPolicyDetailPageState?.event?.data?.value?.policyDocument}
        title="Download pdf document"
        id="downloadPolicy"
        style={{ display: 'none' }}
      />
    );
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <BackArrowComp />
          {/* <Header {...(staticPageContentConfig?.header || {})} /> */}
        </>
      );
    }
    return null;
  };

  const onCardClick = (id: string) => {
    console.log(`card clicked`, id);
    blockchainProofSend('START', {
      payload: {
        ...transactionListState?.event?.data?.value?.timelineData,
        cardId: id,
      },
    });
    let _cardDetail = srv?.agent?.getFormatTimelineDetailSync({
      ...transactionListState?.event?.data?.value?.timelineData,
      cardId: id,
    });
    console.log('card detail', _cardDetail);

    if (
      Array.isArray(_cardDetail?.data?.data) &&
      _cardDetail?.data?.data?.length > 0
    ) {
      if (!cardModal) {
        setCardModal(true);
      }
      setCardId(id);
    }
  };

  const onCardClose = () => {
    if (cardModal) {
      setCardModal(!cardModal);
    }
  };

  const onAckModalClose = () => {
    if (ackModal) {
      setAckModal(!ackModal);
    }
  };

  const onTriggerModal = (data: any) => {
    console.log('Receipt modal trigger', data);
    if (!receiptModal) {
      setReceiptModal(true);
    }
  };

  const onReceiptModalClose = () => {
    if (receiptModal) {
      setReceiptModal(!receiptModal);
    }
  };

  const submitCancel = (data: any) => {
    console.log('cancel Policy', data);
    if (cancelModal) {
      setCancelModal(!cancelModal);
    }
    cancelPolicySend('START', {
      payload: data,
    });
  };

  const _renderModal = () => {
    if (cardModal) {
      let _temp = srv?.agent.getFormatTimelineDetailSync({
        ...transactionListState?.event?.data?.value?.timelineData,
        cardId,
      });
      console.log(`_temp data`, _temp);
      return (
        <TimelineDetailModal
          showModal={cardModal}
          modalTitle={_temp?.title}
          data={_temp?.data}
          onDeny={onCardClose}
          onTriggerModal={onTriggerModal}
        />
      );
    }
    if (ackModal) {
      console.log(
        `modal data`,
        myPolicyDetailPageState?.event?.data?.value?.acknowledgeData
      );
      return (
        <AcknowledgementModal
          showModal={ackModal}
          modalTitle={'Payout Confirmation'}
          data={myPolicyDetailPageState?.event?.data?.value?.acknowledgeData}
          onDeny={onAckModalClose}
          onAcknowledgement={onAckSubmit}
        />
      );
    }
    if (cancelModal) {
      return (
        <TweetyModal
          key={`${new Date()}`}
          show={true}
          // size={"md"}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Submit Cancellation'}
          onSubmit={submitCancel}
          onHide={() => setCancelModal(false)}
          title={'Cancel Policy'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.cancelPolicy?.FIELDS,
            layout: staticPageContentConfig?.cancelPolicy?.layout,
          }}
        />
      );
    }
  };

  const _renderNestedModal = () => {
    console.log(
      `proof data in container`,
      blockchainProofState?.event?.data?.value
    );

    if (receiptModal) {
      return (
        <TransactionReceiptModal
          showModal={receiptModal}
          modalTitle={'Transaction Receipt'}
          // data={receiptData}
          data={blockchainProofState?.event?.data?.value}
          onDeny={onReceiptModalClose}
        />
      );
    }
  };

  const _renderPage = () => {
    if (state.detail) {
      let productDetail = srv?.agent?.getFormatPolicyDetailSync(state?.detail);
      let _tempItems = [...productDetail?.accordionItems];
      if (
        Array.isArray(
          myPolicyDetailPageState?.event?.data?.value?.accordionItems
        )
      ) {
        _tempItems = [
          ...myPolicyDetailPageState?.event?.data?.value?.accordionItems,
        ];
      }
      if (
        Array.isArray(transactionListState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ..._tempItems,
          ...transactionListState?.event?.data?.value?.accordionItems,
        ];
      }

      if (updateAckStatusState?.matches('UPDATE_ACK_STATUS')) {
        return (
          <StateOSD {...(staticPageContentConfig?.loading?.ackLoading || {})} />
        );
      }
      if (cancelPolicyState?.matches('CANCEL_POLICY')) {
        return (
          <StateOSD
            {...(staticPageContentConfig?.loading?.cancelLoading || {})}
          />
        );
      }
      return (
        <>
          <HeroSection
            {...(productDetail || {})}
            {...(myPolicyDetailPageState?.event?.data?.value || {})}
            accordionItems={_tempItems}
            onHeroButtonClick={onHeroButtonClick}
            carouselItems={
              myPolicyDetailPageState?.event?.data?.value?.carouselItems ?? []
            }
            // timelineDetails={
            //   myPolicyDetailPageState?.event?.data?.value?.timelineDetails?? {listItems:[]}
            // }
            buttons={myPolicyDetailPageState?.event?.data?.value?.buttons}
            timelineCardClick={onCardClick}
          />
          {/* <TimelineComp
            {...(provisionaldetailPageState?.event?.data?.value || {})}
          /> */}
        </>
      );
    }
    if (myPolicyDetailPageState?.matches('RENDER_PAGE')) {
      let _tempItems: any = [];
      if (
        Array.isArray(
          myPolicyDetailPageState?.event?.data?.value?.accordionItems
        )
      ) {
        _tempItems = [
          ...myPolicyDetailPageState?.event?.data?.value?.accordionItems,
        ];
      }
      if (
        Array.isArray(transactionListState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ..._tempItems,
          ...transactionListState?.event?.data?.value?.accordionItems,
        ];
      }
      return (
        <>
          <HeroSection
            {...(myPolicyDetailPageState?.event?.data?.value || {})}
            accordionItems={_tempItems}
            onHeroButtonClick={onHeroButtonClick}
            timelineCardClick={onCardClick}
          />
          {/* <TimelineComp {...(myPolicyDetailPageState?.event?.data?.value || {})}/> */}
        </>
      );
    }
    if (myPolicyDetailPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.retrieveCredentials || {})}
        />
      );
    }
    return null;
  };
  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderNotification()}
      {_renderAnchorLink()}
      {_renderModal()}
      {_renderNestedModal()}
    </>
  );
};
